<template>
  <div style="background-color: #f6f6f6">
    <Header/>
    <div id="cart">
      <div class="contents">
        <div>
          <h2>购物车（{{ getCount }}）</h2>
        </div>
        <div class="cart_title">
          <p v-for="(item, i) in goodsTitle" :key="i" :class="item.className">{{ item.title }}</p>
        </div>
        <a-empty v-if="!cartGoods.length" style="margin: 20px 0"/>
        <div v-for="item in cartGoods" :key="item.companyId">
          <div class="item-company">
            <input type="checkbox" :disabled="supplierCheckDisabled(item)" :checked="groupChecked(item)" class="title_1" style="text-align: center" @click="supplierCheck(item)">
            <span style="font-weight: 550;cursor: pointer" @click="supplierCheck(item)">{{ item.companyName }}</span>
          </div>
          <div class="cart_group">
            <div v-for="goods in item.shoppingCarts" :key="goods.id" class="goods-card" :class="{disabledGoods : checkDisabled(goods)}">
              <div class="title_1" style="text-align: center">
                <input type="checkbox" :disabled="checkDisabled(goods)" :checked="goodsIfCheck(goods)" @click="checkGoods(goods)">
              </div>
              <div class="goods_name title_2" @click="goDetail(goods, checkDisabled(goods))">
                <div class="goods-img">
                  <img :src="getFileUrl(goods.bridgePicUrl) || '/noimage.png'">
                </div>
                <div class="name">
                  <p>{{ goods.name }}</p>
                  <span v-if="!goods.isSalePermission">供应商未对您所在学校开放销售权限</span>
                </div>
              </div>
              <div class="title_3" style="text-align: center">
                <span>{{ goods.points }}</span>
              </div>
              <div class="title_4" style="text-align: center">
                <span class="operBtn" :class="{stopOper: goods.count === 1 || checkDisabled(goods)}" @click="conuntChange('minus', goods, goods.count - 1)"><a-icon type="minus" /></span>
                <div class="buyNum">
                  <input type="number" class="ant-input-number" :disabled="checkDisabled(goods)" v-model="goods.count" @blur="conuntChange('blur', goods, $event.target.value)"/>
                </div>
                <span class="operBtn" :class="{stopOper: checkDisabled(goods)}" @click="conuntChange('plus', goods, goods.count + 1)"><a-icon type="plus"/></span>
              </div>
              <div class="title_5" style="text-align: center">
                <span>{{ (goods.points * goods.count).toFixed(2) }}</span>
              </div>
              <div class="title_6" style="text-align: center">
                <a @click="delGoods(goods)">删除</a>
              </div>
            </div>
          </div>
        </div>
        <div ref="settle" style=""></div>
        <div class="cart-footer" :class="{'cart-footer-b' : settleFixed}">
          <div>
          <span style="margin-right: 10px;">
            <input type="checkbox" class="title_1" style="text-align: center" :disabled="allCheckedDisabled()" :checked="allChecked()" @click="checkAll">
            <span style="cursor: pointer" @click="checkAll">全选</span>
          </span>
            <span style="cursor: pointer" @click="allDel">删除</span>
          </div>
          <div>
            <span style="font-size: 18px;">合计：<span style="font-weight: 550;color: #e44c4c">{{ total }}积分</span></span>
            <a-button type="primary" style="width: 150px;margin-left: 20px" :disabled="!total" @click="goCheckOutOrder">结算</a-button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {delCartGoods, loadCart, updateCartGoods} from "@/api/mall";
import fileUrlMixin from "@/mixins/fileUrlMixin";
import { remove } from 'lodash'
import storage from 'store'
import { selectCartId } from "@/store/mutation-types";

export default {
  mixins: [fileUrlMixin],
  components: {
    Header,
    Footer
  },
  data () {
    return {
      goodsTitle: [
        {
          title: '',
          className: 'title_1'
        },
        {
          title: '商品',
          className: 'title_2'
        },
        {
          title: '积分',
          className: 'title_3'
        },
        {
          title: '数量',
          className: 'title_4'
        },
        {
          title: '小计',
          className: 'title_5'
        },
        {
          title: '',
          className: 'title_6'
        }
      ],
      cartGoods: [],
      selectShoppingCartId: [],
      settleFixed: false
    }
  },
  computed: {
    total () {
      return Number(this.cartGoods.reduce((total, g) =>
          total + g.shoppingCarts.filter(z => z.isSalePermission).reduce((groupTotal, p) => this.selectShoppingCartId.includes(p.shoppingCartId) ? groupTotal + p.points * p.count : groupTotal, 0), 0
      ).toFixed(2))
    },
    getCount () {
      return this.cartGoods.reduce((cnt, g) => {
        return cnt + g.shoppingCarts.length
      }, 0)
    }
  },
  mounted () {
    this.getCartGoods()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleCartFixed)
  },
  updated() {
    window.addEventListener('scroll', this.handleCartFixed)
  },
  methods: {
    getCartGoods () {
      loadCart().then(res => {
        this.cartGoods = res.data
      })
    },
    conuntChange (type, item, count) {
      if (count < 1) {
        item.count = 1
        return
      }
      updateCartGoods({ shoppingCartId: item.shoppingCartId, count: parseInt(count) }).then(() => {
        this.getCartGoods()
      })
    },
    delGoods (goods) {
      delCartGoods([goods.shoppingCartId]).then(res => {
        const isOk = this.$HttpHandlerService.checkCode(res, true, '删除成功')
        if (isOk) {
          this.getCartGoods()
        }
      })
    },
    allDel () {
      if (!this.selectShoppingCartId.length) {
        return this.$message.warning('请选择需要删除的商品')
      }
      delCartGoods(this.selectShoppingCartId).then(res => {
        const isOk = this.$HttpHandlerService.checkCode(res, true, '删除成功')
        if (isOk) {
          this.getCartGoods()
        }
      })
    },
    goDetail (goods, disabled) {
      if (disabled) return
      this.$router.push({
        path: `/goodsDetail`,
        query: {
          id: goods.id
        }
      })
    },
    goCheckOutOrder () {
      storage.set(selectCartId, this.selectShoppingCartId)
      this.$router.push({
        path: `/checkout-order`
      })
    },
    goodsIfCheck (goods) {
      return this.selectShoppingCartId.includes(goods.shoppingCartId)
    },
    checkGoods (goods) {
      if (this.goodsIfCheck(goods)) {
        remove(this.selectShoppingCartId, key => key === goods.shoppingCartId)
      } else {
        this.selectShoppingCartId.push(goods.shoppingCartId)
      }
      this.selectShoppingCartId = [...this.selectShoppingCartId]
    },
    groupChecked (item) {
      const shoppingCarts = item.shoppingCarts.filter(g => g.isSalePermission)
      if (!shoppingCarts.length) return false
      return shoppingCarts.every(item => {
        return this.selectShoppingCartId.includes(item.shoppingCartId)
      })
    },
    supplierCheck (item) {
      if (this.groupChecked(item)) {
        item.shoppingCarts.forEach(i => {
          remove(this.selectShoppingCartId, key => key === i.shoppingCartId)
        })
      } else {
        this.selectShoppingCartId = Array.from(new Set(this.selectShoppingCartId.concat(item.shoppingCarts.filter(g => g.isSalePermission).map(r => r.shoppingCartId))))
      }
      this.selectShoppingCartId = [...this.selectShoppingCartId]
    },
    allChecked () {
      if (!this.cartGoods.length) return false
      const cartGoodsLength = this.cartGoods.every(item => {
        return item.shoppingCarts.filter(g => g.isSalePermission).length
      })
      if (!cartGoodsLength) return false
      return this.cartGoods.every(item => {
        return item.shoppingCarts.filter(g => g.isSalePermission).every(item => {
          return this.selectShoppingCartId.includes(item.shoppingCartId)
        })
      })
    },
    checkAll () {
      if (!this.allChecked()) {
        this.cartGoods.forEach(item => {
          item.shoppingCarts.filter(g => g.isSalePermission).forEach(i => {
            const isTrue = this.selectShoppingCartId.some(function (item) {
              return item === i.shoppingCartId
            })
            if (!isTrue) {
              this.selectShoppingCartId.push(i.shoppingCartId)
            }
          })
        })
      } else {
        this.selectShoppingCartId = []
      }
      this.selectShoppingCartId = [...this.selectShoppingCartId]
    },
    handleCartFixed () {
      const rect = this.$refs.settle.getBoundingClientRect()
      this.settleFixed = window.innerHeight < rect.y
    },
    checkDisabled (goods) {
      return !goods.isSalePermission
    },
    supplierCheckDisabled (item) {
      const shoppingCarts = item.shoppingCarts.filter(g => g.isSalePermission)
      if (!shoppingCarts.length) return true
    },
    allCheckedDisabled () {
      if (!this.cartGoods.length) return true
      const cartGoodsLength = this.cartGoods.every(item => {
        return item.shoppingCarts.filter(g => g.isSalePermission).length
      })
      if (!cartGoodsLength) return true
    }
  }
}
</script>
<style lang="less" scoped>
#cart {
  width: 1200px;
  margin: 0 auto;
  min-height: 95vh;
}
.contents{
  background: #fff;
  border-radius: 10px;
  padding: 20px 30px;
  margin: 20px 0;
  .cart_title{
    display: flex;
    height: 40px;
    line-height: 40px;
    background: #F3F7FF;
    p {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC,PingFangSC-Regular;
      font-weight: 550;
      color: #333;
      border-right: 1px solid #fafafa;
      flex-shrink: 1;
    }
  }
  .title_1{
    width: 40px;
  }
  .title_2{
    width: 420px;
  }
  .title_3{
    width: 170px;
  }
  .title_4 {
    width: 170px;
  }
  .title_5{
    width: 170px;
  }
  .title_6{
    width: 170px;
  }
  .item-company {
    margin: 20px 0;
  }
  .cart_group{
    font-weight: 550;
    border-radius: 10px;
    box-shadow: 0 2px 8px 0 hsla(0,0%,89.8%,.5);
    overflow: hidden;
    padding: 25px 0px;
    .goods-card {
      padding: 10px 0;
      border-bottom: 1px dashed #e6e6e6;
      display: flex;
      align-items: center;
      &.disabledGoods{
        color: #999;
      }
      .goods_name{
        display: flex;
        cursor: pointer;
        align-items: center;
        .goods-img{
          width: 80px;
          height: 80px;
          line-height: 80px;
          margin-right: 10px;
          overflow: hidden;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        .name{
          flex: 1;
          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            margin-bottom: 5px !important;
          }
        }
      }
      .buyNum{
        display: inline-block;
        width: 56px;
        margin: 0 2px;
        font-size: 14px;
        .ant-input-number{
          width: 50px;
          box-sizing: border-box;
          text-align: center;
          color: #232326;
          border: 1px solid #cbcbcb;
          padding: 0;
          background-color: #fff;
          outline: none;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
        }
        input[type='number'] {
          -moz-appearance: textfield !important;
        }
      }
      .operBtn{
        display: inline-block;
        width: 28px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        background: #f6f6f6;
        border-radius: 0 3px 3px 0;
        cursor: pointer;
      }
      .stopOper{
        background: rgba(246, 246, 246, .5);
        cursor: not-allowed;
      }
    }
    .goods-card:last-child{
      border: none;
    }
  }
  .footer {
    background: white;
    position: fixed;
    bottom: 0;
  }
  .cart-footer{
    display: flex;
    justify-content: space-between;
    padding: 20px 0 0 0;
  }
  .cart-footer-b{
    position: fixed;
    bottom: 0;
    background-color: white;
    width: 1140px;
    box-shadow: 0 -1px 8px rgba(0,1,1,.08);
    padding-bottom: 20px;
  }
}
</style>